import React, { useEffect, useState } from "react";
import {
  BsHandThumbsUpFill,
  BsHandThumbsDownFill,
} from "../../../assets/icons/vander";
import { useForm } from "../../../hooks";
import { FeedbackModal } from "../modals";
import {
  useScheduleEventStore,
  useFormMessages,
  useFormEventStore,
} from "../../hooks";
import { LoadingData, SuccessMessage, ErrorMessage } from "../../ui";

const initialFormData = {
  propName: "",
  value: "",
  feedback: "",
};

const initialFormValidations = {};

export const PatientSurgeryResultsTable = ({ patientSurgery }) => {
  // Datos del hook ----------------------------------------//
  const {
    // Methods
    startPatientSurgeryFeedback,
  } = useScheduleEventStore();

  const {
    // Props
    isLoading,
    message,
  } = useFormEventStore();

  // States ------------------------------------------------//
  const [isFeedbackModal, setIsFeedbackModal] = useState(false);
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [formValidations, setFormValidations] = useState(
    initialFormValidations
  );

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  const evaluationFirst = patientSurgery?.evaluations?.EVALUATION?.[0];
  const allergiesQuestion = evaluationFirst?.questions?.find(
    (item) => item.title === "¿Tienes alergias?"
  );
  const allergies = allergiesQuestion?.followUpQuestion?.value ?? null;

  // Funciones ---------------------------------------------//
  const handleFeedback = (data) => {
    const nextFormState = {
      ...formState,
      ...data,
    };

    if (!data.feedback) {
      nextFormState.message = "";
    } else {
      delete nextFormState.message;
    }

    const nextValidations = {
      ...formValidations,
    };

    if (!data.feedback) {
      nextValidations.message = [
        (val) => (val ?? "").toString().trim().length > 0,
        "Escribe tu motivo",
      ];
    } else {
      delete nextValidations.message;
    }

    setFormData(nextFormState);
    setFormValidations(nextValidations);

    if (!data.feedback) {
      setIsFeedbackModal(true);
      return;
    }

    onFeedback(nextFormState);
    return;
  };

  const onFeedback = (formState) => {
    setFormSubmitted(true);
    startPatientSurgeryFeedback(formState);
  };

  const onSubmit = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startPatientSurgeryFeedback(formState);
    }
  };

  // Efectos -----------------------------------------------//
  // useEffect(() => {
  //   console.log(formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log(formValidation);
  // }, [formValidation]);

  useEffect(() => {
    if (!isFeedbackModal && validateForm) {
      setValidateForm(false);
    }
  }, [isFeedbackModal, validateForm, setValidateForm]);

  useEffect(() => {
    if (isFeedbackModal && showSuccessMessage && validateForm) {
      setIsFeedbackModal(false);
    }
  }, [showSuccessMessage, isFeedbackModal, validateForm]);

  const formProps = {
    validateForm,
    formState,
    formValidation,
    onInputChange,
    onSubmit,
    isLoading,
    showErrorMessage,
    messageText,
  };

  return patientSurgery.state === "QUIZ_SEND" ? (
    <div>Quiz enviado</div>
  ) : (
    <>
      {isLoading && <LoadingData />}
      {showSuccessMessage && <SuccessMessage>{messageText}</SuccessMessage>}
      {showErrorMessage && <ErrorMessage>{messageText}</ErrorMessage>}

      <div className="table-responsive shadow border-0">
        <table className="table">
          <thead className="table-primary">
            <tr>
              <th className="border-bottom p-3">Indicador</th>
              <th className="border-bottom p-3">Resultado</th>
            </tr>
          </thead>
          <tbody>
            {patientSurgery.track !== null && (
              <tr>
                <td className="p-3">Riesgo</td>
                <td className="p-3">{patientSurgery.track}</td>
              </tr>
            )}
            {patientSurgery.dasiScore !== null && (
              <tr>
                <td className="p-3">Dasi Score</td>
                <td className="p-3">{patientSurgery.dasiScore}</td>
              </tr>
            )}
            {patientSurgery.mets !== null && (
              <tr>
                <td className="p-3">Mets</td>
                <td className={`p-3 ${patientSurgery.mets >= 4 ? "text-underline-success" : "text-underline-danger" }`}>{patientSurgery.mets}</td>
              </tr>
            )}
            {patientSurgery.cRisk !== null && (
              <tr>
                <td className="p-3">Riesgo cardiovascular</td>
                <td className={`p-3 ${patientSurgery.cRisk <= 6 ? "text-underline-success" : "text-underline-danger" }`}>{patientSurgery.cRisk}</td>
              </tr>
            )}
            {patientSurgery.Cfs !== null && (
              <tr>
                <td className="p-3">Escala de fragilidad</td>
                <td className="p-3">{patientSurgery.Cfs}</td>
              </tr>
            )}
            {allergies !== null && (
              <tr>
                <td className="p-3">Alergias</td>
                <td className="p-3">{allergies}</td>
              </tr>
            )}
            {patientSurgery.asa !== null && (
              <tr>
                <td className="p-3">Clasificación ASA</td>
                <td className="p-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <div>{patientSurgery.asa}</div>
                    <div className="flex-shrink-0">
                      <button
                        className="btn btn-icon btn-danger me-2"
                        onClick={() =>
                          handleFeedback({
                            propName: "asa",
                            value: patientSurgery.asa,
                            feedback: false,
                          })
                        }
                      >
                        <BsHandThumbsDownFill className="icons" />
                      </button>
                      <button
                        className="btn btn-icon btn-secondary "
                        onClick={() =>
                          handleFeedback({
                            propName: "asa",
                            value: patientSurgery.asa,
                            feedback: true,
                          })
                        }
                      >
                        <BsHandThumbsUpFill className="icons" />
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <FeedbackModal
        isOpen={isFeedbackModal}
        setIsOpen={setIsFeedbackModal}
        formProps={formProps}
      />
    </>
  );
};
